import { SCHEDULE } from 'crm-message-bus/types/ActivityCreatorTypes';
import { buildActivityCreatorActionHook } from './activityCreatorActionBuilder';
export const useScheduleMeetingAction = buildActivityCreatorActionHook(SCHEDULE);